/**
 * SE-28: un ELEV isi poate schimba clasa doar la inceputul anului scolar — 1 iulie – 1
 * octombrie, ambele capete incluse, in ora Romaniei. Oglinda EXACTA a gardei din backend
 * (`UserService.inFereastraDeSchimbareAClasei`, `1e484a26` — `MonthDay.of(7,1)` .. `MonthDay.of(10,1)`,
 * `ZoneId.of("Europe/Bucharest")`): aceleasi capete, acelasi fus, ca sa nu arate frontendul
 * selectul activ intr-o zi in care backendul tot refuza cu 400.
 *
 * Fus orar EXPLICIT, nu ora locala a dispozitivului: un elev cu telefonul pe alt fus (calatorie,
 * cont desincronizat) ar vedea fereastra deschisa/inchisa la un moment gresit fata de server.
 */

const FUS_ORAR_SCOLAR = 'Europe/Bucharest';

const INCEPUT_FEREASTRA = { luna: 7, zi: 1 }; // 1 iulie
const SFARSIT_FEREASTRA = { luna: 10, zi: 1 }; // 1 octombrie, inclusiv

/** Luna+ziua curenta, in fusul Romaniei — indiferent de fusul dispozitivului. */
function luniZiInBucuresti(data: Date): { luna: number; zi: number } {
    const parti = new Intl.DateTimeFormat('en-CA', {
        timeZone: FUS_ORAR_SCOLAR,
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(data);
    const luna = Number(parti.find((p) => p.type === 'month')?.value);
    const zi = Number(parti.find((p) => p.type === 'day')?.value);
    return { luna, zi };
}

/**
 * `acum` e injectabila (implicit `new Date()`) — testabila pe limite fara sa depinda de
 * ceasul sistemului la rularea testelor.
 */
export function inFerestraSchimbareClasa(acum: Date = new Date()): boolean {
    const { luna, zi } = luniZiInBucuresti(acum);
    const cursor = luna * 100 + zi;
    // Fereastra nu trece peste capatul de an (iulie < octombrie), deci comparatia directa e
    // suficienta — acelasi comentariu ca in backend.
    return cursor >= INCEPUT_FEREASTRA.luna * 100 + INCEPUT_FEREASTRA.zi
        && cursor <= SFARSIT_FEREASTRA.luna * 100 + SFARSIT_FEREASTRA.zi;
}

export const TEXT_FEREASTRA_SCHIMBARE_CLASA =
    'Clasa se poate schimba doar în perioada 1 iulie – 1 octombrie';
